import React from "react";
import Modal from "react-bootstrap/Modal";
import { XCircle, Save } from "react-feather";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { PUT } from "../../../../api/adminApi";

export default function ChangeBalance({
  modal: {
    show,
    data: { id, name },
  },
  setModal,
  getItems,
}) {
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      category: 2, // Default to the first category
      changeType: 1, // Default to "increase"
      point: 0, // Default value for the amount
      reason: "", // Default reason
    },
  });

  const pointTypes = [
    { value: 2, label: "Секционный" },
    { value: 1, label: "Панельный" },
    { value: 4, label: "Котлы" },
    { value: 3, label: "Реферальный" },
  ];

  const pointActions = [
    { value: 1, label: "Увеличить" },
    { value: 2, label: "Уменьшить" },
  ];

  const onHide = () => {
    setModal({ show: false, data: null });
  };

  const onSubmit = async (data) => {
    const transformedData = {
      category: data.category,
      changeType: data.changeType,
      point: parseFloat(data.point), // Ensure the amount is parsed correctly
      reason: data.reason,
      personId: id,
    };

    const response = await PUT(
      "/services/admin/api/user-change-balance",
      transformedData,
    );

    if (response?.success) {
      getItems();
      onHide();
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h3> Изменение баланса продавца:</h3>
          <p
            style={{
              fontSize: 15,
              color: "#4f66ff",
              padding: 0,
              margin: 0,
              marginTop: 5,
            }}
          >
            {name}
          </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="flex flex-col justify-between items-center gap-4 w-full mt-2">
            {/* Category Select */}
            <div
              style={{ width: "100%" }}
              className="flex flex-row gap-2 items-center justify-between"
            >
              <label className="block text-sm font-medium mb-1">
                Тип баланса
              </label>
              <div style={{ width: 250 }}>
                <Controller
                  name="category"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={pointTypes}
                      value={pointTypes.find(
                        (option) => option.value === field.value,
                      )}
                      onChange={(option) => field.onChange(option.value)}
                    />
                  )}
                />
              </div>
            </div>

            {/* Action Select */}
            <div
              style={{ width: "100%" }}
              className="flex flex-row gap-2 items-center justify-between"
            >
              <label className="block text-sm font-medium mb-1">Действие</label>
              <div style={{ width: 250 }}>
                <Controller
                  name="changeType"
                  control={control}
                  defaultValue="1"
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={pointActions}
                      value={pointActions.find(
                        (option) => option.value === field.value,
                      )}
                      onChange={(option) => field.onChange(option.value)}
                    />
                  )}
                />
              </div>
            </div>

            {/* Amount Input */}
            <div
              style={{ width: "100%" }}
              className="flex flex-row justify-between"
            >
              <label className="block text-sm font-medium mb-1">Значение</label>
              <input
                type="number"
                className="w-full border rounded p-2"
                style={{ width: 250, borderColor: "#979595" }}
                {...control.register("point", { valueAsNumber: true })}
              />
            </div>
          </div>

          {/* Reason Input */}
          <div className="mt-4 flex flex-col">
            <label className="block mb-2">Причина</label>
            <textarea
              className="w-full border rounded p-2"
              {...control.register("reason", {
                required: "Обязательна для заполнения",
              })}
              placeholder="Введите причину изменений"
            />
            {errors.reason && (
              <span className="text-danger text-sm mt-1">
                {errors.reason.message}
              </span>
            )}
          </div>

          {/* Buttons */}
          <div
            className="flex flex-row justify-end gap-4 w-full mt-2"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              type="button"
              onClick={onHide}
              className="btn btn-light-dark flex items-center"
            >
              <XCircle size={14} className="mr-2" />
              Отмена
            </button>
            <button
              type="submit"
              className="btn btn-light-primary flex items-center"
            >
              <Save size={14} className="mr-2" />
              Сохранить
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
